import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Button, Stack, Table, Text } from '@mantine/core';

import { useGetBoardInvitations } from 'api/boards';

import { InvitationDelete } from './InvitationDelete';
import { MemberInvitationModal } from '../common';

export const Invitations = () => {
  const { organisationId, boardId } = useParams() as {
    organisationId: string;
    boardId: string;
  };
  const { t } = useTranslation('organisations');
  const { data: invitations } = useGetBoardInvitations({
    path: { organisationId, boardId },
  });
  const [invitationModalOpened, setInvitationModalOpened] = useState(false);

  return (
    <Stack spacing="xl">
      <Box>
        <Button color="green" onClick={() => setInvitationModalOpened(true)}>
          {t('organisationView.boards.invitations.inviteButton')}
        </Button>
        <MemberInvitationModal
          opened={invitationModalOpened}
          onClose={() => setInvitationModalOpened(false)}
        />
      </Box>
      <Table
        sx={theme => ({
          '& tbody': {
            '& tr': {
              borderBottom: `1px solid ${theme.colors.gray[1]}`,
              '& td': {
                padding: theme.other.spacing(2),
                border: 'none',
                '&:last-child': {
                  textAlign: 'right',
                },
              },
            },
          },
        })}
      >
        <tbody>
          {invitations?.map(invitation => (
            <tr key={invitation.id}>
              <td>
                <Text>{invitation.user.email}</Text>
              </td>
              <td>
                <InvitationDelete invitation={invitation} />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Stack>
  );
};
